module.exports = __webpack_public_path__ + "static/Jimmy-Marcelin-4cae7617ff3bf1cc1c7bad6155b6a0fd.jpg";